import Api from './../abstract'
import { APP_TOKEN_NAME } from '@/config'
import { getQueryStringPhase2 } from '@/utils'

export let GET_LIST_TEMPLATE = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let page = params.payload.page || null
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-templates?${getQueryStringPhase2(filter, sort, page)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let CREATE_PICKUP_TEMPLATE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-templates`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    let data = params.payload.data
    return new Api(url, 'post', successCallback, errorCallback, { headers, data })
};
export let UPDATE_PICKUP_TEMPLATE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-templates/${params.payload.data.id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    let data = params.payload.data
    return new Api(url, 'put', successCallback, errorCallback, { headers, data })
};
export let DELETE_PICKUP_TEMPLATE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-templates/${params.payload.template_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'delete', successCallback, errorCallback, { headers })
};
export let GET_DETAIL_PICKUP_TEMPLATE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-templates/${params.payload.template_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let GET_ALL_PICKUP_TEMPLATE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-templates/master`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let CREATE_PICKUP_SCHEDULE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-route`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    let data = params.data
    return new Api(url, 'post', successCallback, errorCallback, { headers ,data })
};
export let GET_PICKUP_SCHEDULE = (params, successCallback, errorCallback) => {
    let date = params.payload.date || null
    let url = `${process.env.VUE_APP_API_URL}/admin/schedule/pickup-route?date=${date}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
